import { AxiosResponse } from 'axios';
import AxiosInstanceYalo from './AxiosInstanceYalo';

export const IDENTIFIER_TYPE_BSUID = 'bsuid';

interface CloseChatBaseParams {
  roomId: string;
  botId: string;
  tags: string[];
  comment?: string;
}

type CloseChatParams =
  | (CloseChatBaseParams & { phone: string; bsuid?: never })
  | (CloseChatBaseParams & { bsuid: string; phone?: never });

export const closeChat = async ({
  roomId,
  botId,
  tags,
  phone,
  comment,
  bsuid,
}: CloseChatParams): Promise<AxiosResponse> =>
  AxiosInstanceYalo.post('v1/chat/close', {
    roomId,
    comment,
    botId,
    tags,
    ...(bsuid ? { userIdentifier: bsuid, identifierType: IDENTIFIER_TYPE_BSUID } : { phone }),
  });
